"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var QuestionFIcon = function QuestionFIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.5 13.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm0-12.3a7.3 7.3 0 1 0 7.3 7.3 7.3 7.3 0 0 0-7.3-7.3zm1.624 7.146l-.207.196A1.7 1.7 0 0 0 9.2 10v.2H7.8V10a3.046 3.046 0 0 1 1.168-2.485l.173-.167c.48-.472.675-.7.673-1.073 0-1.04-1.132-1.07-1.261-1.07-.138 0-1.347.032-1.347 1.192v.2h-1.4v-.2A2.588 2.588 0 0 1 8.569 3.84a2.868 2.868 0 0 1 1.81.601 2.271 2.271 0 0 1 .835 1.83 2.816 2.816 0 0 1-1.09 2.076z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12.5 19.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm0-17.3a10.3 10.3 0 1 0 10.3 10.3A10.299 10.299 0 0 0 12.5 2.2zm2.144 9.9l-.113.11a3.321 3.321 0 0 0-1.33 2.79v.2H11.8V15a4.735 4.735 0 0 1 1.77-3.807l.092-.09c.664-.652 1.144-1.122 1.138-1.906A1.998 1.998 0 0 0 12.607 7.2a2.228 2.228 0 0 0-2.424 2.19v.2h-1.4v-.2a3.382 3.382 0 0 1 1.237-2.711 4.082 4.082 0 0 1 2.587-.88A3.36 3.36 0 0 1 16.2 9.194a3.937 3.937 0 0 1-1.556 2.908z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.5 25.5a1 1 0 1 1 1-1 1.002 1.002 0 0 1-1 1zm0-22.3a13.3 13.3 0 1 0 13.3 13.3A13.3 13.3 0 0 0 16.5 3.2zm2.77 13.388c-.137.155-.273.3-.406.443A4.936 4.936 0 0 0 17.2 21v.2h-1.4V21a6.202 6.202 0 0 1 2.039-4.92c.128-.138.256-.276.383-.42.922-1.038 1.588-1.787 1.578-3.13 0-2.3-1.824-3.33-3.632-3.33-1.911 0-3.968 1.132-3.968 3.617v.2h-1.4v-.2a4.715 4.715 0 0 1 1.721-3.782A5.741 5.741 0 0 1 16.168 7.8c2.424 0 5.032 1.478 5.032 4.725a5.76 5.76 0 0 1-1.93 4.063z"
  }));
};

var _default = QuestionFIcon;
exports["default"] = _default;